import * as moment from "moment";

import { ImmunisationTaskType } from "@teamprevent/common/consultations/models";

import { ImmunisationTypeState } from "../immunisationType";

import { Location } from "redux-little-router";

export interface ImmunisationTypeTaskListModel {
    readonly id: string;
    readonly name: string;
    readonly taskType?: string;
    readonly immunisationTypeId?: string;
    readonly listUpdated: moment.Moment;
}

export interface ImmunisationTypeTaskDetailModel extends ImmunisationTypeTaskListModel {
    readonly detailUpdated: moment.Moment;
}

export type ImmunisationTypeTask = ImmunisationTypeTaskListModel | ImmunisationTypeTaskDetailModel;

export interface ImmunisationTypeTaskCreateModel {
    id: string;
    name: string;
    taskType: string;
    immunisationTypeId: string;
}

export interface ImmunisationTypeTaskEditModel {
    id: string;
    name: string;
    taskType: string;
    immunisationTypeId: string;
}

export const IMMUNISATION_TASK_TYPES_OPTIONS = [
    {
        text: "Evidence",
        value: ImmunisationTaskType.Evidence,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "Blood Test",
        value: ImmunisationTaskType.BloodTest,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "Vaccine",
        value: ImmunisationTaskType.Vaccine,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "Results",
        value: ImmunisationTaskType.Results,
        associatedWithImmunisation: true,
        dueDateApplicable: true
    },
    {
        text: "No Further Action",
        value: ImmunisationTaskType.NoFurtherAction,
        associatedWithImmunisation: false,
        dueDateApplicable: false
    }
];

export const IMMUNISATION_REVIEW_TASK = "ImmunisationReviewTask";
export const BOOK_IMMUNISATION_REVIEW_TASK = "BookImmunisationReviewTask";

export interface ImmunisationTypeTaskState {
    readonly immunisationTypeTasks: ImmunisationTypeTask[];
    readonly immunisationTypeTask?: ImmunisationTypeTask;
}

export type AppState = ImmunisationTypeTaskState & { router: Location } & ImmunisationTypeState;
